export enum ActionTypeV1 {
  CREATE_MODEL_CONCEPT_CLASS = 'CREATE_MODEL_CONCEPT_CLASS',
  CREATE_MODEL_CONCEPT_RELATIONSHIP = 'CREATE_MODEL_CONCEPT_RELATIONSHIP',
  CREATE_MODEL_CONCEPT_ATTRIBUTE = 'CREATE_MODEL_CONCEPT_ATTRIBUTE',
  UPDATE_MODEL_CONCEPT_CLASS = 'UPDATE_MODEL_CONCEPT_CLASS',
  UPDATE_MODEL_CONCEPT_RELATIONSHIP = 'UPDATE_MODEL_CONCEPT_RELATIONSHIP',
  UPDATE_MODEL_CONCEPT_ATTRIBUTE = 'UPDATE_MODEL_CONCEPT_ATTRIBUTE',
  DELETE_MODEL_CONCEPT_CLASS = 'DELETE_MODEL_CONCEPT_CLASS',
  DELETE_MODEL_CONCEPT_RELATIONSHIP = 'DELETE_MODEL_CONCEPT_RELATIONSHIP',
  DELETE_MODEL_CONCEPT_ATTRIBUTE = 'DELETE_MODEL_CONCEPT_ATTRIBUTE',
}

export interface BaseActionDataV1 {
  iri: string;
  label?: string;
  description?: string;
  domains?: string[];
  ranges?: string[];
}

export interface ActionIriDataV1 extends BaseActionDataV1 {
  label?: never;
  description?: never;
  domains?: never;
  ranges?: never;
}

export interface ActionModelConceptClassDataV1 extends BaseActionDataV1 {
  domains?: never;
  ranges?: never;
}

export type ActionModelConceptRelationshipDataV1 = BaseActionDataV1;

export type ActionModelConceptAttributeDataV1 = BaseActionDataV1;

export interface CreateOrUpdateClassActionV1 {
  type:
    | ActionTypeV1.CREATE_MODEL_CONCEPT_CLASS
    | ActionTypeV1.UPDATE_MODEL_CONCEPT_CLASS;
  data: ActionModelConceptClassDataV1;
}

export interface CreateOrUpdateRelationshipActionV1 {
  type:
    | ActionTypeV1.CREATE_MODEL_CONCEPT_RELATIONSHIP
    | ActionTypeV1.UPDATE_MODEL_CONCEPT_RELATIONSHIP;
  data: ActionModelConceptRelationshipDataV1;
}

export interface CreateOrUpdateAttributeActionV1 {
  type:
    | ActionTypeV1.CREATE_MODEL_CONCEPT_ATTRIBUTE
    | ActionTypeV1.UPDATE_MODEL_CONCEPT_ATTRIBUTE;
  data: ActionModelConceptAttributeDataV1;
}

export interface DeleteConceptActionV1 {
  type:
    | ActionTypeV1.DELETE_MODEL_CONCEPT_CLASS
    | ActionTypeV1.DELETE_MODEL_CONCEPT_RELATIONSHIP
    | ActionTypeV1.DELETE_MODEL_CONCEPT_ATTRIBUTE;
  data: ActionIriDataV1;
}

export type ActionV1 =
  | CreateOrUpdateClassActionV1
  | CreateOrUpdateRelationshipActionV1
  | CreateOrUpdateAttributeActionV1
  | DeleteConceptActionV1;
